import merge from 'lodash/merge';

const CC_PAYMENT_ALLOWED_CODES = ['us', 'ca', 'uk', 'nz', 'au'];
const DEFAULT_LOCALE = 'en';

export default class User {
  static NAME = 'user';

  static getDetailsConfig = () => ({
    url: '/v1/users/details',
    dataPath: ['userProfileInfo']
  });

  static getTypeConfig = () => ({
    url: '/user-type'
  });

  static getListConfig = () => ({
    url: '/customer/summary/v1/?fields=contactInfo,userRoles',
    dataPath: ['consumers']
  });

  constructor(user) {
    this.init(user);

    const userContactInfo = user?.contactInfo || {};
    const roles = user?.userRoles || {};

    // this.userId = userContactInfo.userId;
    // this.userName = userContactInfo.userName;
    // this.firstName = userContactInfo.firstName;
    // this.lastName = userContactInfo.lastName;
    this.isSCMS = roles.scms;
    this.isCSR = roles.csr;
    this.locale = user?.displayLang || userContactInfo?.country?.languageCode || DEFAULT_LOCALE;
    this.countryCode = userContactInfo?.country?.isoCode || '';
  }

  init(data) {
    merge(this, data);
  }

  creditCardPaymentAllowed() {
    return CC_PAYMENT_ALLOWED_CODES.includes(this.countryCode.toLowerCase());
  }
}
